import { css } from 'emotion';

export const checklistFilters = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 20px 0;

  > div:last-child {
    margin-top: 20px;
  }

  @media (min-width: 1095px) {
    flex-direction: row;
    > div:last-child {
      margin-top: 0px;
    }
  }
`;

export const searchBox = css`
  width: 420px;
  @media (min-width: 1095px) {
    width: 290px;
  }
`;

export const filterButton = css`
  margin-left: 10px;
`;

export const searchBoxFilters = css`
  display: flex;
`;

export const overlay = css`
  width: 400px;
`;
